import { useContext } from 'react'

import PaymentContext from './payment-context'

const usePayment = () => {
  const context = useContext(PaymentContext)
  return context
}

export default usePayment
